import React from "react"
import {Button, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {Link} from "react-router-dom";

interface PersonaTopBarProps {
    personaType: any;
    page: any;
    changePage: any;
    submitting: boolean;
    setOpenContentBrowser: any;
    handlePersonaSave: any;
}

export const PersonaTopBar: React.FC<PersonaTopBarProps> = ({ personaType, page, changePage, submitting, setOpenContentBrowser, handlePersonaSave}) => {

    return (
        <div className="content-header">
            <div className="left" style={{display: "flex", marginLeft: "300px"}}>
                {personaType === "default" && (<>
                    <ToggleButtonGroup
                        color="primary"
                        value={page}
                        exclusive
                        onChange={(e, newValue) => {
                            if (newValue) {
                                changePage(newValue)
                            }
                        }}
                        style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    >
                        <ToggleButton className="testing" value={"content"}>Content</ToggleButton>
                        <ToggleButton className="testing" value={"stims"}>Stims</ToggleButton>
                        <ToggleButton className="testing" value={"stories"}>Stories</ToggleButton>
                        <ToggleButton className="testing" value={"watch"}>Watch</ToggleButton>
                        <ToggleButton className="testing" value={"watchStims"}>Watch Stims</ToggleButton>
                        <ToggleButton className="testing" value={"reel"}>Reel</ToggleButton>
                        <ToggleButton className="testing" value={"reelStims"}>Reel Stims</ToggleButton>
                    </ToggleButtonGroup>
                </>)}
                {personaType === "reel" && (<>
                    <ToggleButtonGroup
                        color="primary"
                        value={page}
                        exclusive
                        onChange={(e, newValue) => {
                            if (newValue) {
                                changePage(newValue)
                            }
                        }}
                        style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    >
                        <ToggleButton className="testing" value={"content"}>Reel</ToggleButton>
                        <ToggleButton className="testing" value={"stims"}>Reel Stims</ToggleButton>
                    </ToggleButtonGroup>
                </>)}
                {personaType === "streamer" && (<>
                    <ToggleButtonGroup
                        color="primary"
                        value={page}
                        exclusive
                        onChange={(e, newValue) => {
                            if (newValue) {
                                changePage(newValue)
                            }
                        }}
                        style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    >
                        <ToggleButton className="testing" value={"content"}>Content</ToggleButton>
                        <ToggleButton className="testing" value={"stims"}>Stims</ToggleButton>
                    </ToggleButtonGroup>
                </>)}
                {personaType === "video" && (<>
                    <ToggleButtonGroup
                        color="primary"
                        value={page}
                        exclusive
                        onChange={(e, newValue) => {
                            if (newValue) {
                                changePage(newValue)
                            }
                        }}
                        style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                    >
                        <ToggleButton className="testing" value={"video"}>Video</ToggleButton>
                        <ToggleButton className="testing" value={"videoStims"}>Video Stims</ToggleButton>
                    </ToggleButtonGroup>
                </>)}
            </div>
            <div className="right" style={{display: "flex"}}>
                <Button
                    disabled={submitting}
                    style={{marginRight: "10px"}}
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenContentBrowser(true)}
                    className="spacer">Link Content
                </Button>
                <Link to="/new-personas">
                    <Button disabled={submitting} style={{marginRight: "10px"}} variant="contained" color="primary"
                            className="spacer">Back</Button>
                </Link>
                <Button
                    disabled={submitting}
                    style={{height: "40px"}}
                    variant="contained"
                    color="primary"
                    onClick={handlePersonaSave}>Save
                </Button>
            </div>
        </div>
    )
}
